import React, { useState, useEffect } from 'react';
import PageTitle from '../shared/PageTitle';
import { noticeAPI } from '../../services/api';

const OwnerRules = () => {
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRules = async () => {
      try {
        const response = await noticeAPI.getRules();
        setRules(response.data);
      } catch (err) {
        console.error('Error fetching rules:', err);
        setError('Failed to load rules.');
      } finally {
        setLoading(false);
      }
    };
    fetchRules();
  }, []);

  if (loading) {
    return (
      <div className="container-fluid mt-4 activity-container">
        <PageTitle icon="fa-gavel" title="Society Rules" />
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container-fluid mt-4 activity-container">
        <PageTitle icon="fa-gavel" title="Society Rules" />
        <div className="alert alert-danger">{error}</div>
      </div>
    );
  }

  return (
    <div className="container-fluid mt-4 activity-container">
      <PageTitle icon="fa-gavel" title="Society Rules" />
      {rules.length === 0 ? (
        <div className="alert alert-info">
          <i className="fas fa-info-circle me-2"></i>
          No rules have been published yet.
        </div>
      ) : (
        <div className="card">
          <div className="card-body p-0">
            <ul className="list-group list-group-flush">
              {rules.map(rule => (
                <li key={rule.id} className="list-group-item">
                  <h5 className="mb-2">{rule.title}</h5>
                  <p className="mb-0 text-muted">{rule.description}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default OwnerRules; 